import React from 'react';

import { UpdateViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { Checkbox } from 'components/WrappedComponents';
import { useApi } from 'hooks/ApiStoreContext';
import { CSSUtils } from 'utils/CSSUtils';

import { ModificationUtilisateurFormValues } from '../ModalModification';
import {
  generateUpdateUserRequestDtoFromFormData,
  ModificationUserFieldProps,
  validateUpdateUserRequest,
} from '../utils';

function CheckboxActif({
  values,
  userId,
  disabled = false,
}: ModificationUserFieldProps): React.ReactElement {
  const cuController = useApi().ComptesUtilisateursControllerApi;
  const key: keyof ModificationUtilisateurFormValues = 'actif';

  return (
    <Checkbox
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Utilisateur activé',
          rules: [
            {
              validator: async (
                _rule,
                value: boolean | undefined,
              ): Promise<void> => {
                const requestObject = generateUpdateUserRequestDtoFromFormData({
                  ...values,
                  [key]: value,
                });

                return await validateUpdateUserRequest(
                  userId,
                  cuController,
                  requestObject,
                  UpdateViolationDtoFormFieldEnum.ACTIF,
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      checkboxProps={{ disabled: disabled }}
    />
  );
}

export default CheckboxActif;
